import axios from "axios";

const API_URL = "https://api.komorotel.com/api";

export const fetchRoomsCalendar = async (hotelId, startDate, endDate) => {

  const res = await axios.get(
    `${API_URL}/calendar/${hotelId}`,
    {
      params: {
        startDate,
        endDate
      },
      withCredentials:true
    }
  );

  return res.data;
};

export const updateTarif = async (
  roomId,
  dateDebut,
  dateFin,
  price
) => {



  // cas prix de base
  await axios.put(
      `${API_URL}/tarifs/roomprices/${roomId}`,
      {
        dateDebut,
        dateFin,
        price
      },
      {withCredentials: true}
    );

  

};
export const updateRatePlanPrice = async (
  ratePlanId,
  roomId,
  startDate,
  endDate,
  price
) => {
  await axios.put(
    `${API_URL}/tarifs/rateprices/${ratePlanId}/${roomId}`,
    {
      startDate,
      endDate,
      price
    },
    { withCredentials: true }
  );
};

export const updateInventory = async (
  roomId,
  dateDebut,
  dateFin,
  nombreDisponible
) => {
  await axios.put(
    `${API_URL}/rooms/${roomId}/inventory`,
    { dateDebut, dateFin, nombreDisponible },
    { withCredentials: true }
  );
};

export const updateStatus = async (
  roomId,
  dateDebut,
  dateFin,
  statut
) => {
  await axios.put(
    `${API_URL}/rooms/${roomId}/status`,
    { dateDebut, dateFin, statut },
    { withCredentials: true }
  );
};

export const createRoom = async (hotelId, roomDetails) => {
  await axios.post(
    `https://api.komorotel.com/api/rooms/${hotelId}`,
    {
      title: roomDetails.title,
      desc: roomDetails.desc,
      maxPeople: parseInt(roomDetails.maxPeople),
      price: parseInt(roomDetails.price),
      nombreDisponible: parseInt(roomDetails.inventory),
      capaciteInitiale: parseInt(roomDetails.inventory),

      // 🔥 AJOUT ICI
      photos: roomDetails.photos
    },
    { withCredentials: true }
  );
};
export const updateRoomBasePrice = async (roomId, price) => {
  try {
    await axios.put(
      `${API_URL}/rooms/${roomId}/price`,
      { price },
      { withCredentials: true }
    );
  } catch (err) {
    console.error("Erreur updateRoomBasePrice:", err);
    throw err;
  }
};
export const updateRatePlan = async (ratePlanId, data) => {
  try {
    const res = await axios.put(
      `${API_URL}/tarifs/rateplans/${ratePlanId}`,
      data,
      { withCredentials: true }
    );

    return res.data;

  } catch (err) {
    console.error("Erreur updateRatePlan:", err);
    throw err;
  }
};